import React from 'react'

import { GeneralExternalLink } from '@api/general-external-links'

import { ArrowSvg } from '@svg/react'

interface GeneralExternalLinkFrameProps {
  onCloseGeneralExternalLinkFrame: () => void
  generalExternalLink: GeneralExternalLink
  isFullscreen: boolean
}
function GeneralExternalLinkFrame({
  onCloseGeneralExternalLinkFrame,
  generalExternalLink,
  isFullscreen,
}: GeneralExternalLinkFrameProps) {
  return (
    <div
      className={`fixed left-0 z-30 w-screen bg-secondaryColour ${
        isFullscreen
          ? 'top-0 h-screen'
          : 'top-9 h-page-container overflow-hidden rounded-t-3xl'
      }`}
    >
      <button
        type="button"
        className="absolute left-5 top-5 z-3 rounded bg-white p-1 drop-shadow-40"
        onClick={onCloseGeneralExternalLinkFrame}
      >
        <ArrowSvg className="h-8 w-8" strokeColor="#000" />
      </button>

      <div className="absolute left-1/2 top-1/2 z-1 -translate-x-1/2 -translate-y-1/2">
        <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-mainColour border-t-transparent" />
      </div>

      <iframe
        key={generalExternalLink?.linkUrl}
        className="relative z-2 h-full w-full overflow-hidden border-0"
        title={generalExternalLink?.label}
        src={generalExternalLink?.linkUrl}
        height="100%"
        width="100%"
      />
    </div>
  )
}

export default GeneralExternalLinkFrame
